export function tiebreakerGuesses(winners, cards, currentWeek) {
  return cards.flatMap(card => {
    const actual = winners?.[card.Week]?.data?.tiebreaker;
    if (card.Week >= currentWeek || actual == null || actual === '' || card.TieBreaker == null || card.TieBreaker === '') return [];
    const difference = Math.abs(Number(actual) - Number(card.TieBreaker));
    return Number.isFinite(difference) ? [[Number(difference.toFixed(1)), card.Week, card.Tid]] : [];
  }).sort((a, b) => a[0] - b[0]);
}
